

// import React, { useRef } from "react";
// import "./ContactForm.css";
// import { Icon } from "@iconify/react";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { useGSAP } from "@gsap/react";

// gsap.registerPlugin(ScrollTrigger);

// const ContactForm = () => {
//   const sectionRef = useRef(null);
//   const textRef = useRef(null);
//   const formElementsRef = useRef([]);

//   useGSAP(() => {
//     const section = sectionRef.current;
//     const formElements = formElementsRef.current;

//     gsap.from(textRef.current, {
//       scrollTrigger: {
//         trigger: textRef.current,
//         start: "top 80%",
//         toggleActions: "play none none reverse",
//       },
//       opacity: 0,
//       y: 50,
//       duration: 1,
//       ease: "power3.out",
//     });

//     gsap.from(formElements, {
//       scrollTrigger: {
//         trigger: section.querySelector("form"),
//         start: "top 80%",
//         toggleActions: "play none none reverse",
//       },
//       opacity: 0,
//       y: 50,
//       duration: 1,
//       stagger: 0.2,
//       ease: "power3.out",
//     });
//   });

//   return (
//     <div className="ContactForm md:px-[7vw] py-7" ref={sectionRef}>
//       <div className="text" ref={textRef}>
//         <h3>Feel free to contact us</h3>
//         <p>We are here to answer any question you may have</p>
//       </div>

//       <form>
//         <div className="flex gap-8 mt-12 items-center md:flex-row flex-col">
//           <div
//             className="input-field"
//             ref={(el) => (formElementsRef.current[0] = el)}
//           >
//             <input type="text" placeholder="First name*" />
//           </div>
//           <div
//             className="input-field"
//             ref={(el) => (formElementsRef.current[1] = el)}
//           >
//             <input type="text" placeholder="Last name*" />
//           </div>
//         </div>
//         <div className="flex gap-8 mt-12 items-center md:flex-row flex-col">
//           <div
//             className="input-field"
//             ref={(el) => (formElementsRef.current[2] = el)}
//           >
//             <input type="email" placeholder="Your email*" />
//           </div>
//           <div
//             className="input-field"
//             ref={(el) => (formElementsRef.current[3] = el)}
//           >
//             <input type="text" placeholder="Subject*" />
//           </div>
//         </div>
//         <div
//           className="input-field mt-12"
//           ref={(el) => (formElementsRef.current[4] = el)}
//         >
//           <input type="text" placeholder="Message*" />
//         </div>

//         <button
//           type="submit"
//           ref={(el) => (formElementsRef.current[5] = el)}
//         >
//           <span>Send message</span>
//           <Icon icon="iconamoon:send" width="24" height="24" />
//         </button>
//       </form>
//     </div>
//   );
// };

// export default ContactForm;

import React, { useContext, useRef, useState } from "react";
import "./ContactForm.css";
import { Icon } from "@iconify/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingContext, { LoadingCon } from "../../../Context/LoadingContext/LoadingContext";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);

const ContactForm = () => {
  const { t , i18n} = useTranslation()

  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const formElementsRef = useRef([]);

  const LoadContext = useContext(LoadingCon);
  const setLoading = LoadContext.setLoading;

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("name", form.firstName);
    formData.append("lastName", form.lastName);
    formData.append("email", form.email);
    formData.append("phone_number", form.phone);
    formData.append("message", form.message);

    try {
      const res = await axios.post("https://sunmedagency.com/api/contact-us", formData);
      console.log(res);
      toast.success("Message sent successfully!");
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  useGSAP(() => {
    const section = sectionRef.current;
    const formElements = formElementsRef.current;

    gsap.from(textRef.current, {
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "power3.out",
    });

    gsap.from(formElements, {
      scrollTrigger: {
        trigger: section.querySelector("form"),
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 50,
      duration: 1,
      stagger: 0.2,
      ease: "power3.out",
    });
  });

  return (
    <div className="ContactForm md:px-[7vw] py-7" ref={sectionRef}>
      <div className="text" ref={textRef}>
        <h3>{t("Feel free to contact us")}</h3>
        <p>{t("We are here to answer any question you may have")}</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="flex gap-8 mt-12 items-center md:flex-row flex-col">
          <div
            className="input-field"
            ref={(el) => (formElementsRef.current[0] = el)}
          >
            <input
              type="text"
              placeholder={t("First name*")}
              value={form.firstName}
              onChange={(e) => setForm({ ...form, firstName: e.target.value })}
              required
            />
          </div>
          <div
            className="input-field"
            ref={(el) => (formElementsRef.current[1] = el)}
          >
            <input
              type="text"
              placeholder={t("Last name*")}
              value={form.lastName}
              onChange={(e) => setForm({ ...form, lastName: e.target.value })}
              required
            />
          </div>
        </div>
        <div className="flex gap-8 mt-12 items-center md:flex-row flex-col">
          <div
            className="input-field"
            ref={(el) => (formElementsRef.current[2] = el)}
          >
            <input
              type="email"
              placeholder={t("Your email*")}
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </div>
          <div
            className="input-field"
            ref={(el) => (formElementsRef.current[3] = el)}
          >
            <input
              type="number"
              placeholder={t("Phone number*")}
              value={form.subject}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              required
            />
          </div>
        </div>
        <div
          className="input-field mt-12"
          ref={(el) => (formElementsRef.current[4] = el)}
        >
          <input
            type="text"
            placeholder={t("Message*")}
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            required
          />
        </div>

        <button
          type="submit"
          ref={(el) => (formElementsRef.current[5] = el)}
        >
          <span>{t("Send message")}</span>
          <Icon icon="iconamoon:send" width="24" height="24" />
        </button>
      </form>
    </div>
  );
};

export default ContactForm;

